import { createElement, type FC } from 'react'
type Icon = FC<{ className?: string }>
const icon = (d: string): Icon => ({ className }) =>
  createElement(
    'svg',
    {
      className,
      viewBox: '0 0 24 24',
      width: 24,
      height: 24,
      overflow: 'visible',
      fill: 'none',
      stroke: 'currentColor',
      strokeWidth: 1.8,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
    createElement('path', { d }),
  )
export const ReplyIcon = icon('M10 8 4 12l6 4v-3h5a5 5 0 0 1 5 5c0-6-3-10-10-10z')
export const CopyIcon = icon('M8 8h11v11H8zM5 16H4V5h11v1')
export const PinIcon = icon('M9 4h6l-1 5 3 3v2H7v-2l3-3zM12 14v6')
export const OpenProfileIcon = icon('M8 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8m-5 10v-2a5 5 0 0 1 10 0v2m3-10h5m-2-2 2 2-2 2')
export const DMIcon = icon('M4 5h16v11H8l-4 3zM9 10h6m-3-3v6')
export const NotificationsIcon = icon('M18 9a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9m-8 12h4')
export const LeaveIcon = icon('M10 4H5v16h5m4-4 4-4-4-4m4 4H9')
export const MoveColumnIcon = icon('M4 12h16m-3-3 3 3-3 3M7 9l-3 3 3 3')
export const NewCardIcon = icon('M4 5h16v14H4zM12 9v6M9 12h6')
export const NewColumnIcon = icon('M5 4h10v16H5zm13 5v8m-4-4h8')
export const PasteIcon = icon('M7 5h10v15H7zM10 3h4v4h-4zm2 8v6m-3-3h6')
export const SelectColumnIcon = icon('M6 4h12v16H6zM6 7h12')
export const ReorderIcon = icon('M8 7h8M8 12h8M8 17h8M5 7h.01M5 12h.01M5 17h.01')
export const FitToRangeIcon = icon('M8 5H5v14h3M16 5h3v14h-3M9 12h6')
export const NewEventIcon = icon('M5 6h14v13H5zM8 3v5m8-5v5m-4 4v5m-2-2h4')
export const HideFromRailIcon = icon('M3 3l18 18M10 6.4A10 10 0 0 1 21 12s-3.5 6-9 6a10 10 0 0 1-3.5-.6M6.3 6.3A12 12 0 0 0 3 12s3.5 6 9 6c.8 0 1.6-.1 2.3-.4')
export const ResetIcon = icon('M4 12a8 8 0 1 0 2-5.3M4 4v4h4')
export const MoveToBandIcon = icon('M4 6h16M4 18h16m-8-9v6m-3-3 3-3 3 3')
